module.exports = __webpack_public_path__ + "img/banner4.be250e42.png";